import { createContext } from 'react';

const HeaderContext = createContext('header');

export default HeaderContext;
